import React, { useState, useEffect } from "react";
import moment from "moment";

import { useV2getChatSessionsQuery } from "./chatSessionApiSlice";

import {
    Header,
    Label,
    Button,
    Icon,
    Popup,
    Loader,
    Table,
    Segment,
    Grid,
    Pagination,
} from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { PAGE_SIZE, formatDate } from "../../../constants";
import V2ChatSessionDetail from "./v2ChatSessionDetail";

import { useV2deleteChatSessionMutation } from "./chatSessionApiSlice";

const V2ChatSessionList = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get("page");
    const page_size = queryParams.get("page_size");
    const agent = queryParams.get("agent");
    const user = queryParams.get("user");
    const partner = queryParams.get("partner");

    // get query params from frontend url -> remove null ones to pass to backend
    let qp = { page, page_size, user, agent, partner };
    qp = Object.entries(qp)
        .filter((e) => e[1])
        .reduce((accumulator, [k, v]) => {
            accumulator[k] = v;
            return accumulator;
        }, {});

    // GET chat sessions
    const { data, isLoading, isSuccess, isError, error } =
        useV2getChatSessionsQuery({ ...qp });

    // to handle chat session selection
    const [selectedChatSession, setSelectedChatSession] = useState(null);
    const handleSelectChatSession = (chat_session) => {
        setSelectedChatSession(chat_session);
    };

    const [deleteChatSession, { data: deletedChatSession, isLoading: isDeleting }] = useV2deleteChatSessionMutation();
    const handleDelete = (chat_session_id) => {
        deleteChatSession(chat_session_id);
        // window.location.reload();
    }

    const handlePaginationChange = (e, { activePage }) => {
        setSelectedChatSession(null);
        let url = `/chatsessionslist-v2?page=${activePage}&page_size=${PAGE_SIZE}`;
        if (user) {
            url = url + `&user=${user}`;
        }
        if (user) {
            url = url + `&agent=${user}`;
        }
        if (partner) {
            url = url + `&partner=${partner}`;
        }
        navigate(url);
    };

    let content;
    if (isLoading) {
        content = <Loader active />;
    } else if (isSuccess) {
        content = (
            <>
                <Grid columns={2}>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {" "}
                            <Header as="h1">
                                <Icon name="comments outline" /> Chat Sessions
                            </Header>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            {" "}
                            <Header as="h1">Chat Logs</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Column width={12}>
                        {isLoading && <Loader active />}
                        <Pagination
                            attached="top"
                            ellipsisItem={{
                                content: <Icon name="ellipsis horizontal" />,
                                icon: true,
                            }}
                            firstItem={{
                                content: <Icon name="angle double left" />,
                                icon: true,
                            }}
                            lastItem={{
                                content: <Icon name="angle double right" />,
                                icon: true,
                            }}
                            prevItem={{ content: <Icon name="angle left" />, icon: true }}
                            nextItem={{ content: <Icon name="angle right" />, icon: true }}
                            activePage={page}
                            onPageChange={handlePaginationChange}
                            totalPages={Math.ceil(data.count / page_size)}
                        />
                        <Table compact="very" celled attached>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>ID</Table.HeaderCell>
                                    <Table.HeaderCell>Created At</Table.HeaderCell>
                                    <Table.HeaderCell>User</Table.HeaderCell>
                                    <Table.HeaderCell>Partner</Table.HeaderCell>
                                    <Table.HeaderCell>Language</Table.HeaderCell>
                                    <Table.HeaderCell>Model</Table.HeaderCell>
                                    <Table.HeaderCell>Prompt</Table.HeaderCell>
                                    <Table.HeaderCell>Chat</Table.HeaderCell>
                                    <Table.HeaderCell>Delete</Table.HeaderCell>
                                    <Table.HeaderCell>Detail</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {data.results.map((chat_session, i) => (
                                    <Table.Row
                                        key={chat_session.id}
                                        positive={
                                            selectedChatSession &&
                                            selectedChatSession.id === chat_session.id
                                        }
                                    >
                                        <Table.Cell textAlign="center">
                                            <Label
                                                circular 
                                                active={selectedChatSession && selectedChatSession.id === chat_session.id}
                                            >
                                                <Icon name="comments alternate outline" />
                                                {chat_session.id.slice(0, 5)}
                                            </Label>
                                            </Table.Cell>
                                        <Table.Cell>
                                            {formatDate(chat_session.created_at)}
                                        </Table.Cell>

                                        <Table.Cell>
                                            {chat_session.user ? chat_session.user.username : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {chat_session.partner ? chat_session.partner.name : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {chat_session.language ? chat_session.language : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {chat_session.llm_model ? chat_session.llm_model : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {chat_session.prompt ? chat_session.prompt : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                fluid
                                                size="mini"
                                                icon="comments alternate"
                                                onClick={() => {
                                                    navigate(
                                                        `/chatsessionperform-v2?chatsession_id=${chat_session.id}`
                                                    );
                                                }}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                fluid
                                                size="mini"
                                                icon="trash alternate red"
                                                onClick={() => {
                                                    handleDelete(chat_session.id);
                                                }}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button
                                                size="mini"
                                                fluid
                                                primary
                                                inverted
                                                icon="arrow right"
                                                active={
                                                    selectedChatSession &&
                                                    selectedChatSession.id === chat_session.id
                                                }
                                                onClick={() => {
                                                    handleSelectChatSession(chat_session);
                                                }}
                                            >
                                                {chat_session.chatlog_count}
                                                <Icon name="arrow right" />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        <Pagination
                            attached="bottom"
                            ellipsisItem={{
                                content: <Icon name="ellipsis horizontal" />,
                                icon: true,
                            }}
                            firstItem={{
                                content: <Icon name="angle double left" />,
                                icon: true,
                            }}
                            lastItem={{
                                content: <Icon name="angle double right" />,
                                icon: true,
                            }}
                            prevItem={{ content: <Icon name="angle left" />, icon: true }}
                            nextItem={{ content: <Icon name="angle right" />, icon: true }}
                            activePage={page}
                            onPageChange={handlePaginationChange}
                            totalPages={Math.ceil(data.count / page_size)}
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                        {selectedChatSession ? (
                            <Segment
                                raised
                                placeholder={selectedChatSession.chatlog_count < 1}
                                className="scrollable-right-pane"
                            >
                                {selectedChatSession.chatlog_count > 0 ? (
                                    <V2ChatSessionDetail
                                        // The key prop forces a component to remount when it changes, so
                                        // the component will go through the initial loading state again
                                        // when chat_session_id changes.
                                        key={selectedChatSession.id}
                                        chat_session_id={selectedChatSession.id}
                                    />
                                ) : (
                                    <Header icon>
                                        There are no chat logs in this chat session.
                                    </Header>
                                )}
                            </Segment>
                        ) : (
                            <Segment raised placeholder className="scrollable-right-pane">
                                <Header icon>
                                    Click the button under "Interactions" from the left to see the
                                    chat logs.
                                </Header>
                            </Segment>
                        )}
                    </Grid.Column>
                </Grid>
            </>
        );
    } else if (isError) {
        content = null;
    }

    return content;
}

export default V2ChatSessionList



